import * as auth from '../modules/auth/redux/AuthRedux'
import store from "../../setup/redux/Store"

export function isTokenExp() {
    store.dispatch(auth.actions.isTokenExp(true))
}